import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import '../checkout.css';
import _ from 'lodash';
import validate from 'validate.js';

const pattern = { phoneNumber: /\d{10}/ };

const validatePhoneNumber = {
    phoneNumber: {
        presence: { allowEmpty: false, message: 'is required' },
        numericality: { onlyInteger: true },
        format: pattern.phoneNumber
    }
}

class CheckOutDialogPhoneNumber extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
             phoneNumber: '',
             error: {
                status: true,
                message: ''
             }
        }
    }
    
    handleChangeData = (e) => {
        e.persist();
        this.setState({ phoneNumber: e.target.value });
    }

    componentDidUpdate(prevProps, prevState) {

        if (!_.isEqual(prevState.phoneNumber, this.state.phoneNumber)) {
            const { phoneNumber } = this.state;
            const error = validate({ phoneNumber }, validatePhoneNumber);
            const _isValid = error ? true: false;
            this.setState({ 
                error: {
                    status: _isValid,
                    message: _isValid ? error.phoneNumber[0] : ''
                }
            });
        }

    }

    render() {
        const {
            dialogPhoneNumber,
            CloseDialogPhoneNumber,
            wording,
            applyFormChange
        } = this.props;
        const {
            phoneNumber,
            error
        } = this.state;

        return (
            <Modal
                visible={dialogPhoneNumber}
                width='450'
                effect='fadeInUp'
                onClickAway={() => CloseDialogPhoneNumber()}>
                <div className='m-20'>
                    <div className='dialog-header'>
                        <h4 style={{ color: '#2d64cf' }}>
                            {
                                wording.checkoutPage.dialogPhoneNumber
                                    .title
                            }
                        </h4>
                    </div>
                    <div className='dialog-body mt-20 mb-20'>
                        
                        <input
                            name='phoneNumber'
                            type='text'
                            maxLength='10'
                            placeholder={
                                wording.checkoutPage.dialogPhoneNumber
                                    .phoneNumber
                            }
                            autoComplete="on"
                            value={phoneNumber}
                            onChange={this.handleChangeData}
                        />
                        {error.status && (
                            <p className='error'>
                                {error.message}
                            </p>
                        )}

                    </div>

                    <div className='dialog-action row'>
                        <div className='col-xs-6 col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-dark'
                                disabled={error.status}
                                onClick={async () => {
                                    await CloseDialogPhoneNumber();
                                    applyFormChange(phoneNumber);
                                }}>
                                {wording.checkoutPage.dialogPhoneNumber.ok}
                            </button>
                        </div>
                        <div className='col-xs-6 col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-light-red'
                                onClick={() => CloseDialogPhoneNumber()}>
                                {
                                    wording.checkoutPage.dialogPhoneNumber
                                        .cancel
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = ({ checkout, language }) => ({
    dialogPhoneNumber: checkout.dialogPhoneNumber,
    wording: language.wording
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            CloseDialogPhoneNumber: Actions.CloseDialogPhoneNumber
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckOutDialogPhoneNumber);
